import React from "react";
import Template from "../../components/Template";
import api from "../../services/api";
import ConfirmationModal from "../../components/ConfirmationModal";
import SuccessModal from "../../components/SuccessModal";
import { required, isFile, isDate } from "../../utils/validationRules";
import { useValidation } from "../../hooks/useValidation";
import FormLabel from "../../components/FormLabel";
import { useNavigate } from 'react-router-dom';
import { formatDateWithHour } from "../../utils/date";
import config from "../../config";
import usePermission from "../../hooks/usePermission";

const Relatorios = () => {
    const navigate = useNavigate();
    const podeVerContabilidade = usePermission('VISUALIZAR_RELATORIOS_CONTABILIDADE');
    const podeVerInventario = usePermission('VISUALIZAR_RELATORIOS_INVENTARIO');
    const podeVerPedidosCompra = usePermission('VISUALIZAR_RELATORIOS_PEDIDOS_COMPRA');
    const podeVerDeducaoImpostos = usePermission('VISUALIZAR_RELATORIOS_DEDUCAO_IMPOSTOS');
    const podeVerComparativoMaterial = usePermission('VISUALIZAR_RELATORIOS_MATERIAIS_FORNECEDORES');
    const podeVerMateriaisObra = usePermission('VISUALIZAR_RELATORIOS_MATERIAIS_OBRA');
    const podeVerResumoObras = usePermission('VISUALIZAR_RELATORIOS_RESUMO_OBRAS');
    const podeVerPagamentoPrestadores = usePermission('VISUALIZAR_RELATORIOS_RESUMO_PAGAMENTOS_PRESTADORES');
    const podeVerResumoEmpenho = usePermission('VISUALIZAR_RELATORIOS_RESUMO_EMPENHO');
    const podeVerObrasPorCliente = usePermission('VISUALIZAR_RELATORIOS_CLIENTE_OBRAS');
    const podeVerNotasPorObra = usePermission('VISUALIZAR_RELATORIOS_NOTAS_OBRA');
    const podeVerGeralNotas = usePermission('VISUALIZAR_RELATORIOS_GERAL_NOTAS');
    const podeVerAcompanhamentoFinanceiro = usePermission('VISUALIZAR_RELATORIOS_ACOMPANHAMENTO_FINANCEIRO');
    const podeVerBoletos = usePermission('VISUALIZAR_RELATORIOS_BOLETOS');

    return (
        <Template>
            <form className="w-full px-4 py-6 flex flex-col gap-8">
                {/* Título da Página */}
                <div>
                    <h1 className="text-2xl text-stone-800 font-medium">Relatórios</h1>
                </div>

                <div className="h-auto flex-col justify-start items-start gap-4 flex">
                    {podeVerComparativoMaterial && (
                        <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                            <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/relatorios/comparativomaterial') }}>
                                Comparativo Material
                            </button>
                        </div>
                    )}
                    {podeVerMateriaisObra && (
                        <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                            <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/relatorios/materiais-obra') }}>
                                Materiais por Obra
                            </button>
                        </div>
                    )}
                    {podeVerResumoObras && (
                        <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                            <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/relatorios/resumoobras') }}>
                                Resumo Obras
                            </button>
                        </div>
                    )}
                    {podeVerPagamentoPrestadores && (
                        <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                            <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/relatorios/resumo/pagamentoprestadores') }}>
                                Pagamento Prestadores
                            </button>
                        </div>
                    )}
                    {podeVerResumoEmpenho && (
                        <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                            <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/relatorios/resumo/empenho') }}>
                                Resumo Empenho
                            </button>
                        </div>
                    )}
                    {podeVerObrasPorCliente && (
                        <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                            <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/relatorios/clientes/obras') }}>
                                Obras por Cliente (Material e Serviço)
                            </button>
                        </div>
                    )}
                    {podeVerNotasPorObra && (
                        <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                            <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/relatorios/obra/notas') }}>
                                Notas por Obra (Material e Serviço)
                            </button>
                        </div>
                    )}
                    {podeVerGeralNotas && (
                        <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                            <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/relatorios/geral/notas') }}>
                                Geral de Notas
                            </button>
                        </div>
                    )}
                    {podeVerPedidosCompra && (
                        <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                            <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/relatorios/pedidos-compra') }}>
                                Pedidos de Compra
                            </button>
                        </div>
                    )}
                    {podeVerAcompanhamentoFinanceiro && (
                        <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                            <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/relatorios/acompanhamento-financeiro') }}>
                                Acompanhamento Financeiro de Obras
                            </button>
                        </div>
                    )}
                    {podeVerBoletos && (
                        <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                            <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/relatorios/boletos') }}>
                                Boletos (Fluxo de Caixa)
                            </button>
                        </div>
                    )}
                    {podeVerContabilidade && (
                        <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                            <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/relatorios/contabilidade') }}>
                                Contabilidade
                            </button>
                        </div>
                    )}
                    {podeVerDeducaoImpostos && (
                        <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                            <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/relatorios/deducao-impostos') }}>
                                Dedução de Impostos
                            </button>
                        </div>
                    )}
                    {podeVerInventario && (
                        <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                            <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => { navigate('/relatorios/inventario') }}>
                                Inventário de Patrimônio
                            </button>
                        </div>
                    )}
                </div>
            </form>
        </Template>
    );
};

export default Relatorios;
